import React, { FC }              from 'react';
import { Divider, Header, Icon }  from 'semantic-ui-react';
import { Flexbox }                from './Flexbox';
import { FlexItem }               from './FlexItem';
import { StyledContainer }        from './StyledContainer';
import { FlexAlign, FlexJustify } from '../../types/componentPropTypes';
import { SystemEvent }            from '../../types/events';

export interface ClosableHeaderProps {
	title?: string,
	divider?: boolean,
	containerProps?: object,
	headerProps?: object,
	iconProps?: object,
	
	onClose?( e: SystemEvent ): void,
}

const defaultProps: ClosableHeaderProps = {
	title:          null,
	onClose:        null,
	divider:        true,
	containerProps: {},
	headerProps:    {},
	iconProps:      {},
}

const ClosableHeader: FC<ClosableHeaderProps> = ( { children, ...props } ) => {
	
	return (
		<>
			<StyledContainer { ...props.containerProps }>
				
				<Flexbox align={ FlexAlign.CENTER } justify={ FlexJustify.SPACE_BETWEEN }>
					<FlexItem>
						
						{ props.title && <Header as={ 'h4' } { ...props.headerProps }>{ props.title }</Header> }
					
					</FlexItem>
					<FlexItem noGrow>
						
						{ props.onClose && <Icon { ...props.iconProps }
						                         name={ 'close' }
						                         className={ 'cursor--pointer' }
						                         onClick={ props.onClose }/> }
					
					</FlexItem>
				</Flexbox>
			</StyledContainer>
			
			{ props.divider && <Divider/> }
			
			{ children }
		</>
	)
};

ClosableHeader.defaultProps = defaultProps;

export { ClosableHeader }
